import { Controller } from "stimulus"
export default class extends Controller {
    static targets = [ "discontinued", "backordered", "strategic" ]
    
    discontinued_toggle(event) {
        let formData = new FormData()

        formData.append("discontinued", this.discontinuedTarget.checked);
    
        fetch(this.data.get("update-url"), {
            body: formData,
            method: 'PATCH',
            credentials: "include",
            dataType: "script",
            headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
             },
        })

    }

    backordered_toggle(event) {
        let formData = new FormData()

        formData.append("backordered", this.backorderedTarget.checked);
    
        fetch(this.data.get("update-url"), {
            body: formData,
            method: 'PATCH',
            credentials: "include",
            dataType: "script",
            headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
             },
        })

    }

    strategic_toggle(event) {
        let formData = new FormData()

        formData.append("strategic", this.strategicTarget.checked);
    
        fetch(this.data.get("update-url"), {
            body: formData,
            method: 'PATCH',
            credentials: "include",
            dataType: "script",
            headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
             },
        })

    }
}
